import { toast } from "react-toastify";

export const requestHandler = async (api, setLoading, onSuccess, onError) => {
    try {
        setLoading && setLoading(true);
        const response = await api();
        const { data } = response;

        if (data?.success) {
            onSuccess(data);
        }
    } catch (error) {
        if ([401, 403].includes(error?.response?.status)) {

            localStorage.clear();
            window.location.href = "/";
        }
        toast.error(
            error.response?.data?.message || "Error, please try again...!"
        );
        onError();
    } finally {
        setLoading && setLoading(false);
    }
};
